export class LinearWork {
  /**
   *
   */
  public end_pk: number | null = null;

  /**
   *
   */
  public linear_work_id: number | null = null;

  /**
   *
   */
  public linear_work_name: string = null;

  /**
   *
   */
  public linear_zone_id: number | null = null;

  /**
   *
   */
  public plan_id: number | null = null;

  /**
   *
   */
  public start_pk: number | null = null;
}
